module.exports = __webpack_public_path__ + "img/零售-合格证.2d402256.jpg";